import { userReducer as user } from '@mv-submodules/inplant-user-fe'
import { authReducer } from '@mv-submodules/inplant-coreadapter-fe/auth'
import { checklistReducer } from '@mv-submodules/inplant-checklist-fe-iblu'
import coreControlReducers from '../../inplant-coreadapter-fe/redux/reducers'
import { reducers as chronoReducer } from '@mv-submodules/inplant-chronoframe-fe'
import componentsReducers from '../../mvlabs-components-fe/redux/reducers'
import { combineReducers } from 'redux'
import { reducers as assetManagereReducer } from '@mv-submodules/inplant-asset-manager-fe'

export const config = {
  generic: {
    loginSuccessPath: '/checklist/models-assets',
    plantType: 'inplant',
  },
  plantHalts: {
    enabledActions: (window as any).HALTS_ENABLED_ACTIONS || process.env.REACT_APP_HALTS_ENABLED_ACTIONS || false,
    typeOfInplant: (window as any).TYPE_OF_INPLANT || process.env.REACT_APP_TYPE_OF_INPLANT || 'v2',
    frequentsNotes: (window as any).HALTS_FREQUENTS_NOTES || process.env.REACT_APP_HALTS_FREQUENTS_NOTES || '',
  },
  plantSelector: {
    isMultiPlant: (window as any).MULTI_PLANT || process.env.REACT_APP_MULTI_PLANT || false,
  },
}

export default {
  auth: authReducer,
  checklist: checklistReducer,
  chronoframe: chronoReducer,
  user,
  core: coreControlReducers,
  components: combineReducers(componentsReducers),
  config: () => config,
  assetManager: assetManagereReducer,
}
